import _ from 'lodash';
import Vue from 'vue';

import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, from } from 'apollo-link';
// import { ApolloLink, from } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { InMemoryCache } from 'apollo-cache-inmemory';

import Auth from '@/store/api/auth';
import store from '@/store';
// import router from '@/router'

const ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_GRAPHQL_ROUTE}`;
const httpLink = new HttpLink({ uri: _.trimEnd(ENDPOINT, '/') });

const networkErrorLink = onError(parent => {
    const { networkError, graphQLErrors, operation, forward } = parent;

    if (networkError) {
        store.commit('setError', { code: networkError.statusCode, message: networkError.message });
    } else if (graphQLErrors) {
        // const message = _.get(graphQLErrors, '0.message')
        // switch (message) {
        //     case 'Not Found':
        //         store.commit('setError', { code: 404, message: 'Not Found!' })
        //         break;
        //
        //     default:
        //         store.commit('setError', { code: 400, message: 'Bad API request!' })
        // }
    } else {
        store.commit('setError', { code: 500, message: 'An unknown error has occurred!' });
    }

    return forward(operation);
});

const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers

    operation.setContext({
        headers: {
            Authorization: Auth.getToken() ? `Bearer ${Auth.getToken()}` : null
        }
    });

    return forward(operation).map(response => {
        const context = operation.getContext();
        const {
            response: { headers }
        } = context;

        if (headers) {
            const token = headers.get('Authorization');

            if (token) {
                const jwt = token.split('Bearer');
                if (jwt.length) {
                    const token = _.compact(jwt)[0].trim();
                    store.commit('auth/addTokenToState', token);
                }
            }
        }
        return response;
    });
});

const apolloClient = new ApolloClient({
    link: from([authMiddleware, networkErrorLink, httpLink]),
    cache: new InMemoryCache(),
    connectToDevTools: process.env.NODE_ENV === 'development'
});

export const apolloProvider = new VueApollo({
    defaultClient: apolloClient
});

Vue.use(VueApollo);

export default apolloClient;
